export const GREEN = '#65C93E';

export const TURQUOISE = '#00B0B9';

export const WHITE = '#FFF';

export default [GREEN, TURQUOISE, WHITE];
